import {AccountInfo} from '@azure/msal-browser';

const getToken = (accounts: AccountInfo[]) => {
    let token = '';
    let role = '';
    const tokenObj = accounts[0].idToken;
    if (tokenObj) {
        token = tokenObj;
    }
    const roleArr = accounts[0].idTokenClaims?.roles;
    if (roleArr) {
        role = roleArr[0];
    }
    return {token, role};
}

export {getToken};